export const registerInitialValues1: any = {
  pmdc: "",
  phone_number: "",
};

export const registerInitialValues2: any = {
  name: "",
  speciality: "",
  years_of_experience: "",
  city: "",
  gender: "",
  email: "",
  profile_picture: null,
};

export const aboutInitialValues: any = {
  about_text: "",
};

export const addManufacturerInitialValues: any = {
  manufacturer_name: "",
};
export const addCategoryInitialValues: any = {
  category_name: "",
};
export const addSupplierInitialValues: any = {
  supplier_name: "",
  contact_person: "",
  phone_number: "",
  email: "",
};
export const addCustomerInitialValues: any = {
  name: "",
  phone_number: "",
  // email: "",
};
export const addUserManagementInitialValues: any = {
  name: "",
  designation: "",
  phone_number: "",
  email: "",
};

export const addMedicineFormulaInitialValues: any = {
  drug_formula_name: "",
  drug_formula_description: "",
};
export const addBatchInitialValues: any = {
  batch_no: "",
  quantity: "",
  sell_price: "",
  cost_price: "",
  // production_date: "",
  // expiry_date: "",
  // supplier_id: "",
  pharmacy_id: "",
  medicine_id: "",
};

export const addMedicineInitialValues: any = {
  medicine_name: "",
  dose: "",
  generic_name: "",
  category_id: "",
  pharmacy_id: "",
  manufacturer_id: "",
  drug_formula_id: "",
};
export const addMedicalInitialValues: any = {
  pharmacy_id: "",
  category_id: "",
  manufacturer_id: "",
  product_id: "",
  name: "",
  weight: "",
};

export const RegMedicalInitialValues: any = {
  medicine_name: "",
  dose: "",
  category_id: "",
  pharmacy_id: "",
  manufacturer_id: "",
};

export const addOwnerClinicInitialValues: any = {
  clinic_name: "",
  owner_id: "",
  address: "",
  clinic_phone_number: "",

  logo_url: "",
};
export const addClinicOwnerInitialValues: any = {
  name: "",
  phone_number: "",
};
export const addStaffInitialValues: any = {
  name: "",
  role_id: "",
  email: "",
  contact_number: "",
  address: "",
  pin: "",
  gender: "",
};
export const registerStaffInitialValues: any = {
  name: "",
  designation: "",
  email: "",
  phone_number: "",
  profile_picture: "",
};
export const addSpecialityInitialValues: any = {
  name: "",
  description: "",
};
export const addSpecialitytagInitialValues: any = {
  tags: "",
};
export const addUniversityInitialValues: any = {
  uni_id: "",
  name: "",
  country: "",
  region: "",
  verified: "",
};
export const addSubscriptiojnInitialValues: any = {
  doctors: "",
  staff: "",
  attachments: "",
  price: "",
};
export const addBankInitialValues: any = {
  name: "",
};
export const addReleseInitialValues: any = {
  release_notes: "",
  is_locking_version: "",
  release_version: "",
};
